export const parseTopics = (input: string) => {
  if (!input.trim()) return [];

  // If input contains delimiters, split it
  if (input.includes(",") || input.includes("-")) {
    return input
      .split(/,|\s-\s/)
      .map((topic) => topic.trim())
      .filter((topic) => topic.length > 0)
      .filter((topic, index, self) => self.indexOf(topic) === index);
  }

  return [input];
};
